(function ($) {

  $( document ).ready(function() {

    $("body").css('overflow', 'unset');

    var faqLoadedMobile = new CustomEvent("faq-loaded");

    const searchFrom = $('#block__hkbis-faq__search-form');
    const searchInput = $('#block__hkbis-faq__search-form__search-input-text');
    const catDataElement = $('#block__hkbis-faq__cat-data');
    const loadingElement = $('#block__hkbis-faq__loading');

    const categoryContentDesktop = $('#block__hkbis-faq__category-content-desktop');
    const categoryContentMobile = $('#block__hkbis-faq__category-content-mobile');
    const faqContent = $('#block__hkbis-faq__faq-content');
    const noResultsContent = $('#block__hkbis-faq__search-form__no-results');

    const loadCategoriesAndFirstFAQ = (showLoadingAnimation = false) => {
      if(showLoadingAnimation) {
        loadingElement.show();
      }
      let params = {};
      params["search"] = searchInput.val();
      params["specific_cat_ids"] = catDataElement.data('cats');

      let data  = formatData(params);
      $.ajax({
          type: 'post',
          url: ajaxurl,
          data: {action: 'faq_form', data},
          success: function (response) {
            response = JSON.parse(response);
            if (response.noResultHTML) {

              noResultsContent.html(response.noResultHTML);
              faqContent.html('');
              categoryContentDesktop.html('');

              loadingElement.hide();


            } else {

              noResultsContent.html('');

              if (response.catHTMLMobile) {
                categoryContentMobile.html(response.catHTMLMobile);
                setEventCategoryHandlers('mobile');
                document.dispatchEvent(faqLoadedMobile);
              }

              if (response.catHTMLDesktop) {
                categoryContentDesktop.html(response.catHTMLDesktop);
                setEventCategoryHandlers('desktop');
              }

              if (response.faqHTML) {
                faqContent.html(response.faqHTML);
                loadingElement.hide();


              } else {

                if (response.faqIDs && response.faqIDs.length > 0) {
                  loadFAQs(response.faqIDs[0]);
                }
              }
              selectFirstCat();
            }

          },
          error: function () {
              console.log("Error");
              loadingElement.hide();
          }
      });
    }

    const loadFAQs = (categoryID) => {
      if (!categoryID) {
        return;
      }

      let params = {};
      params["cat"] = categoryID;
      params["search"] = searchInput.val();

      let data  = formatData(params);

      $.ajax({
          type: 'post',
          url: ajaxurl,
          data: {action: 'faq_cat_posts', data},
          success: function (response) {
            response = JSON.parse(response);
            if (response.faqHTML) {
              faqContent.html(response.faqHTML);
            }
            loadingElement.hide()
          },
          error: function () {
              console.log("Error");
              loadingElement.hide();
          }
      });
    }

    const setEventCategoryHandlers = (type = undefined) => {

      if(type === 'mobile' || type === undefined) {
        const navSelect = $( ".block__hkbis-faq__category-mobile-form");
        navSelect.on('change', function () {
          loadFAQs(parseInt($(this).val()));
        })
      }

      if(type === 'desktop' || type === undefined) {
        const navElements = $( ".block__hkbis-faq__cat-nav-element-desktop");
        navElements.on('click', function() {
          if (!$(this).hasClass('active')) {
            navElements.removeClass('active');
            // navElements.parent().removeClass('order-0').addClass('order-1');
            $(this).addClass('active');
            // $(this).parent().removeClass('order-1').addClass('order-0');
            const category = $(this).data('cat');
            loadFAQs(parseInt(category));
          }
        });
      }
    };

    const selectFirstCat = () => {
      const navElementsDesktop = $( ".block__hkbis-faq__cat-nav-element-desktop" );
      navElementsDesktop.removeClass('active');
      // navElementsDesktop.parent().removeClass('order-0').addClass('order-1');
      navElementsDesktop.first().addClass('active');
      // navElementsDesktop.first().parent().removeClass('order-1').addClass('order-0');
    };

    function formatData(params) {
      let data  = {};
      for (let param in params) {
          if (params[param] != "") {
              data[param] = params[param];
          }
      }
      return data;
    }

    loadCategoriesAndFirstFAQ(true);
    searchFrom.on('submit', function() {
      loadCategoriesAndFirstFAQ(true);
    });
  });
})(jQuery);
